const errorTranslations = {
  en: {
    ALL_TIME_SLOTS_FULL: "All time slots are full",
    BOOKED_THESE_WEEKS: "you have already booked within %weeks% week(s)",
    DAY_NOT_FOUND: "Day is not found",
    NO_USER_BY_HASH: "No found user by hash",
    NEW_END_TIME_INVALID: "New end time cannot be less than start time",
    NOT_FOUND_PENALTY: "Penalty not found",
    PASSPORT_ID_OR_STATUS_ID_IS_REQUIRED: "PassportID or StatusID is required",
    QR_CODE_ALREADY_HAS_USER: "QrCode already has user",
    QR_CODE_NOT_FOUND: "QrCode not found",
    QR_CODE_WITH_ID_NOT_EXIST: "QrCode not found",
    QUEUE_NOT_FOUND: "Queue not found",
    TODAY_NO_AID_DAY: "Today no aid day",
    UNAVAILABLE_DAY: "Unavailable day next will be %nextAvailableDay%",
    USER_BLOCKED: "User is blocked",
    USER_HAS_PENALTY: "User has penalty",
    USER_NOT_FOUND: "User not found",
    USER_NOT_IN_LINE: "User is not in line"
  },
  ua: {
    ALL_TIME_SLOTS_FULL: "Усі часові слоти зайняті",
    BOOKED_THESE_WEEKS: "Ви вже бронювали протягом %weeks% тижня(ів)",
    DAY_NOT_FOUND: "День не знайдено",
    NO_USER_BY_HASH: "Користувача за хешем не знайдено",
    NEW_END_TIME_INVALID: "Новий час завершення не може бути меншим за час початку",
    NOT_FOUND_PENALTY: "Штраф не знайдено",
    PASSPORT_ID_OR_STATUS_ID_IS_REQUIRED: "Потрібен PassportID або StatusID",
    QR_CODE_ALREADY_HAS_USER: "QrCode вже має користувача",
    QR_CODE_NOT_FOUND: "QrCode не знайдено",
    QR_CODE_WITH_ID_NOT_EXIST: "QrCode не знайдено",
    QUEUE_NOT_FOUND: "Чергу не знайдено",
    TODAY_NO_AID_DAY: "Сьогодні немає дня допомоги",
    UNAVAILABLE_DAY: "День недоступний буде доступний %nextAvailableDay%",
    USER_BLOCKED: "Користувач заблокований",
    USER_HAS_PENALTY: "Користувач має штраф",
    USER_NOT_FOUND: "Користувача не знайдено",
    USER_NOT_IN_LINE: "Користувач не в черзі"
  },
  de: {
    ALL_TIME_SLOTS_FULL: "Alle Zeitfenster sind belegt",
    BOOKED_THESE_WEEKS: "Sie haben für %weeks% Wochen gebucht",
    DAY_NOT_FOUND: "Tag wurde nicht gefunden",
    NO_USER_BY_HASH: "Benutzer mit Hash wurde nicht gefunden",
    NEW_END_TIME_INVALID: "Neue Endzeit kann nicht kleiner als Startzeit sein",
    NOT_FOUND_PENALTY: "Strafe wurde nicht gefunden",
    PASSPORT_ID_OR_STATUS_ID_IS_REQUIRED: "PassportID oder StatusID ist erforderlich",
    QR_CODE_ALREADY_HAS_USER: "QrCode hat bereits einen Benutzer",
    QR_CODE_NOT_FOUND: "QrCode wurde nicht gefunden",
    QR_CODE_WITH_ID_NOT_EXIST: "QrCode wurde nicht gefunden",
    QUEUE_NOT_FOUND: "Warteschlange wurde nicht gefunden",
    TODAY_NO_AID_DAY: "Heute ist kein Hilfstag",
    UNAVAILABLE_DAY: "Tag ist nicht verfügbar - nächster verfügbarer Tag ist %nextAvailableDay%",
    USER_BLOCKED: "Benutzer ist gesperrt",
    USER_HAS_PENALTY: "Benutzer hat eine Strafe",
    USER_NOT_FOUND: "Benutzer wurde nicht gefunden",
    USER_NOT_IN_LINE: "Benutzer ist nicht in der Warteschlange"
  }
};

export const getErrorTranslation = (
  code: string,
  message: string,
  lang: string = "en",
  params: Record<string, string> = {}
): string => {
  // Normalize language (default to "en" if not found)
  const normalizedLang = errorTranslations[lang] ? lang : "en";

  const translatedMessage =
    (code && errorTranslations[normalizedLang]?.[code]) ||
    message ||
    code ||
    "Unknown error";

  return translatedMessage.replace(/%(\w+)%/g, (match, paramName) =>
    params[paramName] !== undefined ? params[paramName] : match
  );
};

